module.exports = __webpack_public_path__ + "img/ptzc-large-four.d084337b.png";